/**
 * Absolutizes a same-origin relative URI. keycloak-js sends
 * silentCheckSsoRedirectUri verbatim as the OIDC redirect_uri, so a relative
 * value (as configured in environment.authorization) must be resolved to an
 * absolute one first, or the Keycloak server rejects/mis-resolves it and the
 * silent SSO check never completes.
 */
export function absolutizeUri(uri: string): string {
  return new URL(uri.replace(/^\/+/, ''), `${window.location.origin}/`).href;
}

export interface KeycloakLogoutConfig {
  keycloakUrl: string;
  realm: string;
  clientId: string;
}

/**
 * OIDC RP-initiated logout URL WITHOUT id_token_hint. Keycloak shows one
 * confirmation click before completing the logout. Used when silent session
 * recovery didn't yield a token.
 */
export function buildFallbackLogoutUrl(config: KeycloakLogoutConfig): string {
  const base = config.keycloakUrl.replace(/\/+$/, '');
  const endpoint = `${base}/realms/${encodeURIComponent(
    config.realm
  )}/protocol/openid-connect/logout`;

  const params = new URLSearchParams({
    client_id: config.clientId,
    post_logout_redirect_uri: `${window.location.origin}/`,
  });

  return `${endpoint}?${params.toString()}`;
}
